(() => {
  const getMetaPixelState = () => {
    if (!window.__backpackAdAgencyMetaPixelState) {
      window.__backpackAdAgencyMetaPixelState = {
        initializedPixels: {},
      };
    }

    return window.__backpackAdAgencyMetaPixelState;
  };

  const loadMetaPixelBase = () => {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  };

  const initializeMetaPixel = (section) => {
    const pixelId = section.dataset.metaPixelId;
    if (!pixelId) return;

    loadMetaPixelBase();

    const state = getMetaPixelState();

    if (!state.initializedPixels[pixelId]) {
      window.fbq('init', pixelId);
      state.initializedPixels[pixelId] = true;
    }
  };

  const initializeLineCtaTracking = (section) => {
    const pixelId = section.dataset.metaPixelId;
    if (!pixelId) return;

    const lineCta = section.querySelector('a.backpack-ad-lp__line-image-link');
    if (!lineCta || lineCta.dataset.metaClickTrackingInitialized === 'true') return;

    lineCta.dataset.metaClickTrackingInitialized = 'true';
    lineCta.addEventListener('click', () => {
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('trackSingleCustom', pixelId, 'LineCtaClick');
        }
      } catch {
        // Meta Pixelの失敗にかかわらず、通常のリンク遷移を継続する。
      }
    });
  };

  const playVideoBestEffort = (video) => {
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          // Autoplayが拒否されても、他の動画やLPの処理は継続する。
        });
      }
    } catch {
      // 動画再生の失敗がCTAや計測処理へ影響しないようにする。
    }
  };

  const loadDeferredVideo = (video) => {
    if (video.dataset.backpackVideoLoaded === 'true') return;

    video.dataset.backpackVideoLoaded = 'true';
    video.preload = 'metadata';

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.load();
  };

  const initializeBackpackVideos = (section) => {
    const priorityVideo = section.querySelector(
      '.backpack-ad-lp__video[data-backpack-video-priority="true"]'
    );
    const deferredVideos = Array.from(
      section.querySelectorAll('.backpack-ad-lp__video[data-backpack-video-deferred="true"]')
    );

    if (priorityVideo) {
      playVideoBestEffort(priorityVideo);
    }

    if (deferredVideos.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      deferredVideos.forEach((video) => {
        loadDeferredVideo(video);
        playVideoBestEffort(video);
      });
      return;
    }

    const sectionStyle = window.getComputedStyle(section);
    const sectionIsScrollable =
      /(auto|scroll)/.test(sectionStyle.overflowY) && section.scrollHeight > section.clientHeight;
    const observerRoot = sectionIsScrollable ? section : null;
    const preloadMargin = sectionIsScrollable ? section.clientHeight : window.innerHeight;

    const preloadObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          loadDeferredVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: observerRoot,
        rootMargin: `${preloadMargin}px 0px`,
        threshold: 0,
      }
    );

    const playbackObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            loadDeferredVideo(video);
            playVideoBestEffort(video);
            return;
          }

          try {
            video.pause();
          } catch {
            // pauseの失敗が他の動画やLPの処理へ影響しないようにする。
          }
        });
      },
      {
        root: observerRoot,
        threshold: 0.01,
      }
    );

    deferredVideos.forEach((video) => {
      preloadObserver.observe(video);
      playbackObserver.observe(video);
    });
  };

  const getAnalysisTrackingState = () => {
    if (!window.__backpackAdAgencyAnalysisTrackingState) {
      window.__backpackAdAgencyAnalysisTrackingState = {
        trackedEvents: {},
        maxScrollPositions: {
          document: 0,
          section: 0,
        },
        timersInitialized: false,
        scrollTrackingInitialized: false,
        scrollCheckScheduled: false,
      };
    }

    return window.__backpackAdAgencyAnalysisTrackingState;
  };

  const trackAnalysisEventOnce = (state, pixelId, eventName) => {
    if (state.trackedEvents[eventName]) return;

    state.trackedEvents[eventName] = true;

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackSingleCustom', pixelId, eventName);
      }
    } catch {
      // Meta Pixelの失敗がLPの表示や操作へ影響しないようにする。
    }
  };

  const getScrollMetrics = (section) => {
    const sectionStyle = window.getComputedStyle(section);
    const sectionIsScrollable =
      /(auto|scroll)/.test(sectionStyle.overflowY) && section.scrollHeight > section.clientHeight;

    if (sectionIsScrollable) {
      return {
        key: 'section',
        position: section.scrollTop,
        distance: section.scrollHeight - section.clientHeight,
      };
    }

    const documentElement = document.documentElement;
    const body = document.body;
    const documentHeight = Math.max(
      documentElement.scrollHeight,
      documentElement.offsetHeight,
      documentElement.clientHeight,
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0,
      body ? body.clientHeight : 0
    );
    const viewportHeight = window.innerHeight || documentElement.clientHeight;

    return {
      key: 'document',
      position: window.scrollY || documentElement.scrollTop || (body ? body.scrollTop : 0),
      distance: documentHeight - viewportHeight,
    };
  };

  const checkScrollAnalysisEvents = () => {
    const state = getAnalysisTrackingState();
    state.scrollCheckScheduled = false;

    const section = document.querySelector(
      '.backpack-ad-lp[data-backpack-agency-lp="true"][data-meta-pixel-id]'
    );
    if (!section) return;

    const pixelId = section.dataset.metaPixelId;
    const metrics = getScrollMetrics(section);
    if (metrics.distance <= 0) return;

    state.maxScrollPositions[metrics.key] = Math.max(
      state.maxScrollPositions[metrics.key],
      metrics.position
    );

    const maxScrollRatio = state.maxScrollPositions[metrics.key] / metrics.distance;

    if (maxScrollRatio >= 0.5) {
      trackAnalysisEventOnce(state, pixelId, 'Scroll_50');
    }

    if (maxScrollRatio >= 0.8) {
      trackAnalysisEventOnce(state, pixelId, 'Scroll_80');
    }
  };

  const scheduleScrollAnalysisCheck = () => {
    const state = getAnalysisTrackingState();
    if (state.scrollCheckScheduled) return;

    state.scrollCheckScheduled = true;
    window.requestAnimationFrame(checkScrollAnalysisEvents);
  };

  const initializeAnalysisTracking = (section) => {
    const pixelId = section.dataset.metaPixelId;
    if (!pixelId) return;

    const state = getAnalysisTrackingState();

    if (!state.timersInitialized) {
      state.timersInitialized = true;

      window.setTimeout(() => {
        trackAnalysisEventOnce(state, pixelId, 'Stay_10s');
      }, 10000);

      window.setTimeout(() => {
        trackAnalysisEventOnce(state, pixelId, 'Stay_30s');
      }, 30000);
    }

    if (!state.scrollTrackingInitialized) {
      state.scrollTrackingInitialized = true;
      document.addEventListener('scroll', scheduleScrollAnalysisCheck, {
        capture: true,
        passive: true,
      });
      window.addEventListener('resize', scheduleScrollAnalysisCheck, { passive: true });
      scheduleScrollAnalysisCheck();
    }
  };

  const initialize = (section) => {
    if (!section || section.dataset.backpackAgencyInitialized === 'true') return;

    section.dataset.backpackAgencyInitialized = 'true';

    try {
      initializeBackpackVideos(section);
    } catch {
      // 動画処理の失敗がCTAや計測処理へ影響しないようにする。
    }

    initializeMetaPixel(section);
    initializeLineCtaTracking(section);
    initializeAnalysisTracking(section);
  };

  const initializeAll = (root = document) => {
    root
      .querySelectorAll('.backpack-ad-lp[data-backpack-agency-lp="true"]')
      .forEach(initialize);
  };

  initializeAll();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('.backpack-ad-lp[data-backpack-agency-lp="true"]')) {
      initialize(event.target);
      return;
    }

    initializeAll(event.target);
  });
})();
